import React, { useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { Helmet } from "react-helmet";
import CareerModal from "./CareerModal";
import { useAuth } from "../../Store/AuthContext";

export default function Careers() {
  const { webSetting, Pagemetatags } = useAuth();
  const [showModal, setShowModal] = useState(false);

  const handleApplyClick = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  return (
    <>
      <Helmet>
        <title>{Pagemetatags.careers_title}</title>
        <meta name="description" content={Pagemetatags.careers_description} />
        <meta name="keywords" content={Pagemetatags.careers_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename="Careers" mainpage="" />

      <section
        className="propertie-section-4 fix section-padding bg-cover"
        style={{ backgroundImage: `url('assets/img/propertie-bg.jpg')` }}
      >
        <div className="container">
          <div className="propertie-wrapper-3">
            <div className="row">
              <div className="col-lg-2"></div>
              <div className="col-lg-8">
                <div className="gt-details-thumb">
                  {webSetting.careers_img !== "" ? (
                    <img
                      src={webSetting.careers_img}
                      alt=""
                      width="100%"
                      height="100%"
                      style={{ borderRadius: "8px" }}
                    />
                  ) : (
                    <img
                      src="../assets/img/home-3/CareerWhys.webp"
                      alt=""
                      width="100%"
                      height="100%"
                      style={{ borderRadius: "8px" }}
                    />
                  )}
                </div>
              </div>
              <div className="col-lg-2"></div>
            </div>
            {/* <div className="row g-4">
              <div className="col-xl-6 col-lg-6">
                <div className="content">
                  <div className="section-title mb-0">
                    <h2
                      className="wow fadeInUp aboutSectiontitle"
                      data-wow-delay=".3s"
                    >
                      Why Choose Us?
                    </h2>
                  </div>
                  <p className="wow fadeInUp mt-3" data-wow-delay=".5s">
                    We're a collaborative and supportive company seeking
                    talented individuals who are passionate about making a
                    positive impact in Pune. We offer a work environment that
                    fosters:
                  </p>
                  <div className="tab-content">
                    <div id="Photo" className="tab-pane fade show active">
                      <ul className="list-items wow fadeInUp" data-wow-delay=".3s">
                        <li>
                          <i className="flaticon-right-arrow"></i>
                          <span>
                            <strong>Collaboration : </strong>
                            You'll work alongside skilled professionals from
                            diverse backgrounds, fostering a dynamic learning
                            environment.
                          </span>
                        </li>
                        <li>
                          <i className="flaticon-right-arrow"></i>
                          <span>
                            {" "}
                            <strong>Growth Opportunities :</strong>
                            We invest in your development by providing ongoing
                            training and mentorship to help you excel in your
                            career.
                          </span>
                        </li>
                        <li>
                          <i className="flaticon-right-arrow"></i>
                          <span>
                            <strong> Competitive Compensation : </strong>We
                            offer competitive salaries and a comprehensive
                            benefits package to recognize your contributions.
                          </span>
                        </li>
                        <li>
                          <i className="flaticon-right-arrow"></i>

                          <span>
                            <strong>Meaningful Work :</strong>
                            Contribute to landmark projects that will have a
                            lasting impact on Pune's future.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6">
                <div
                  className="propertie-image wow img-custom-anim-right"
                  data-wow-duration="1.3s"
                  data-wow-delay="0.3s"
                >
                  <img src="assets/img/home-3/whychoose.jpeg" alt="img" />
                </div>
              </div>
            </div> */}

            <div className="row whychooseExprince mt-5">
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="house-offer-box section-bg-3 style-2 h-auto">
                  <div className="content mt-0 mb-3">
                    <h3 className="mb-3 aboutSectiontitle">Office Assistant</h3>
                    <h4>Experience : 1-5 Yrs</h4>
                  </div>
                  <div className="whychoseApplybtn">
                    <button
                      className="theme-btn "
                      data-discover="true"
                      onClick={handleApplyClick}
                    >
                      Apply now
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="house-offer-box section-bg-3 style-2 h-auto">
                  <div className="content mt-0 mb-3">
                    <h3 className="mb-3 aboutSectiontitle">Sales Manager</h3>
                    <h4>Experience : 2-7 Yrs</h4>
                  </div>
                  <div className="whychoseApplybtn">
                    <button
                      className="theme-btn "
                      data-discover="true"
                      onClick={handleApplyClick}
                    >
                      Apply now
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="house-offer-box section-bg-3 style-2 h-auto">
                  <div className="content mt-0 mb-3">
                    <h3 className="mb-3 aboutSectiontitle">
                      Pre-Sales Executive
                    </h3>
                    <h4>Experience : 0-5 Yrs</h4>
                  </div>
                  <div className="whychoseApplybtn">
                    <button
                      className="theme-btn "
                      data-discover="true"
                      onClick={handleApplyClick}
                    >
                      Apply now
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="house-offer-box section-bg-3 style-2 h-auto">
                  <div className="content mt-0 mb-3">
                    <h3 className="mb-3 aboutSectiontitle">
                      Real Estate Sales Executive
                    </h3>
                    <h4>Experience : 2-5 Yrs</h4>
                  </div>
                  <div className="whychoseApplybtn">
                    <button
                      className="theme-btn "
                      data-discover="true"
                      onClick={handleApplyClick}
                    >
                      Apply now
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="house-offer-box section-bg-3 style-2 h-auto">
                  <div className="content mt-0 mb-3">
                    <h3 className="mb-3 aboutSectiontitle">
                      Real Estate Accountant
                    </h3>
                    <h4>Experience : 2-7 Yrs</h4>
                  </div>
                  <div className="whychoseApplybtn">
                    <button
                      className="theme-btn "
                      data-discover="true"
                      onClick={handleApplyClick}
                    >
                      Apply now
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="house-offer-box section-bg-3 style-2 h-auto">
                  <div className="content mt-0 mb-3">
                    <h3 className="mb-3 aboutSectiontitle">Others</h3>
                    <h4>Experience : 0-5 Yrs</h4>
                  </div>
                  <div className="whychoseApplybtn">
                    <button
                      className="theme-btn "
                      data-discover="true"
                      onClick={handleApplyClick}
                    >
                      Apply now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CareerModal show={showModal} onClose={handleClose} />
    </>
  );
}
